// frontend/src/themes/palettes/gatinhos.js
import { sharedComponents } from "./shared";
export default {
  muiMode: "light",
  scrollbarColor: "#F0A8C8",
  palette: {
    primary:    { main: "#E5679E" },
    secondary:  { main: "#B388FF" },
    background: { default: "#FDF2F6", paper: "#FFFFFF" },
    text:       { primary: "#4A2438", secondary: "#8A5A72" },
    divider:    "#F6DCE8",
    action:     { hover: "rgba(229,103,158,0.05)", selected: "rgba(229,103,158,0.10)" },
  },
  components: {
    ...sharedComponents,
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 6, backgroundColor: "#FFFFFF" },
        notchedOutline: { borderColor: "#EFC2D8" },
      },
    },
  },
  custom: {
    chat: { sentBg: "#FCE4EE", quotedSentBg: "#F8CFE2", quotedReceivedBg: "#F6EAF0", accent: "#E5679E", contactAccent: "#B388FF" },
    chartPalette: ["#E5679E", "#B388FF", "#FF8A80", "#FFB74D", "#4DB6AC", "#F06292"],
    login: { bg: "#FDF2F6" },
    decorId: "gatinhos",
    headingFont: "Quicksand",
  },
};
